/** Fineri ATC bag count + drawer sync (classic script, fresh asset name). */
(function () {
  if (window.__fineriAtcSyncBound) return;
  window.__fineriAtcSyncBound = true;

  var syncTimer = null;
  var syncInFlight = null;
  var lastKnownCount = null;

  function cfg() {
    return window.FINERI_STOREFRONT || {};
  }

  function cartJsUrl() {
    var paths = cfg().paths || {};
    return paths.cartJs || '/cart.js';
  }

  function sectionId() {
    var el = document.querySelector('[data-fineri-cart-drawer-root]');
    var fromDom = el && el.getAttribute('data-fineri-cart-render-id');
    return fromDom || cfg().cartDrawerSectionId || 'fineri-cart-drawer';
  }

  function readBadgeCount() {
    var sup = document.querySelector('[data-fineri-cart-link] .fineri-header__cart-count');
    if (!sup) return 0;
    var n = parseInt(sup.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  function updateHeaderCartCount(count) {
    var n = typeof count === 'number' ? count : 0;
    lastKnownCount = n;
    var links = document.querySelectorAll('[data-fineri-cart-link]');
    if (!links.length) return;
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var sup = link.querySelector('.fineri-header__cart-count');
      if (n > 0) {
        if (!sup) {
          sup = document.createElement('sup');
          sup.className = 'fineri-header__cart-count';
          link.appendChild(sup);
        }
        sup.textContent = String(n);
      } else if (sup) {
        sup.remove();
      }
    }
  }

  function refreshCartCount() {
    return fetch(cartJsUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart_js');
        return r.json();
      })
      .then(function (cart) {
        updateHeaderCartCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function replaceDrawerHtml(htmlString) {
    if (!htmlString || typeof htmlString !== 'string') return false;
    var cur = document.querySelector('[data-fineri-cart-drawer-root]');
    if (!cur) return false;
    var host = cur.closest('.shopify-section') || cur.closest('[id^="shopify-section-"]');
    if (!host) return false;
    var keepOpen = false;
    var curPanel = cur.querySelector('#FineriCartDrawerPanel');
    if (curPanel && !curPanel.hidden) keepOpen = true;
    var tpl = document.createElement('template');
    tpl.innerHTML = htmlString.trim();
    var incoming =
      tpl.content.querySelector('.shopify-section') ||
      tpl.content.querySelector('[id^="shopify-section-"]') ||
      tpl.content.firstElementChild;
    if (!incoming) return false;
    if (keepOpen) {
      var nextRoot =
        incoming.hasAttribute && incoming.hasAttribute('data-fineri-cart-drawer-root')
          ? incoming
          : incoming.querySelector('[data-fineri-cart-drawer-root]');
      if (nextRoot) {
        var ov = nextRoot.querySelector('.fineri-cart-drawer__overlay');
        var pan = nextRoot.querySelector('#FineriCartDrawerPanel');
        if (ov) ov.hidden = false;
        if (pan) pan.hidden = false;
      }
    }
    if (incoming.hasAttribute && incoming.hasAttribute('data-fineri-cart-drawer-root')) {
      cur.replaceWith(incoming);
      return true;
    }
    host.replaceWith(incoming);
    return true;
  }

  function refreshCartDrawer() {
    if (window.__fineriCartUiStamp && Date.now() - window.__fineriCartUiStamp < 1600) {
      return Promise.resolve(true);
    }
    var openPanel = document.querySelector('[data-fineri-cart-drawer-root] #FineriCartDrawerPanel');
    if (openPanel && !openPanel.hidden) return Promise.resolve(true);
    var id = sectionId();
    return fetch('/?sections=' + encodeURIComponent(id), {
      headers: { Accept: '*/*' },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('sections');
        return r.json();
      })
      .then(function (json) {
        var html =
          (json && typeof json[id] === 'string' && json[id]) ||
          (json && typeof json['fineri-cart-drawer'] === 'string' && json['fineri-cart-drawer']) ||
          '';
        if (!html && json) {
          for (var k in json) {
            if (
              Object.prototype.hasOwnProperty.call(json, k) &&
              typeof json[k] === 'string' &&
              json[k].indexOf('data-fineri-cart-drawer-root') !== -1
            ) {
              html = json[k];
              break;
            }
          }
        }
        if (!html) {
          return fetch('/?section_id=' + encodeURIComponent(id), {
            credentials: 'same-origin',
            cache: 'no-store',
          }).then(function (r2) {
            if (!r2.ok) return false;
            return r2.text().then(function (text) {
              var ok = replaceDrawerHtml(text);
              if (ok) window.__fineriCartUiStamp = Date.now();
              return ok;
            });
          });
        }
        var replaced = replaceDrawerHtml(html);
        if (replaced) window.__fineriCartUiStamp = Date.now();
        return replaced;
      })
      .catch(function () {
        return false;
      });
  }

  function openFineriCartDrawer() {
    var root = document.querySelector('[data-fineri-cart-drawer-root]');
    if (!root) return;
    root.classList.remove('fineri-cart-drawer--gokwik-prefer');
    root.removeAttribute('data-fineri-cart-disabled');
    var overlay = root.querySelector('.fineri-cart-drawer__overlay');
    var panel = root.querySelector('#FineriCartDrawerPanel');
    if (overlay) overlay.hidden = false;
    if (panel) panel.hidden = false;
    document.documentElement.classList.add('fineri-cart-drawer-open');
    var triggers = document.querySelectorAll('[data-fineri-cart-open]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute('aria-expanded', 'true');
    }
  }

  function syncCartUi(options) {
    var opts = options || {};
    if (syncInFlight) {
      return syncInFlight.then(function () {
        if (opts.openDrawer) openFineriCartDrawer();
      });
    }
    var before = typeof opts.expectIncreaseFrom === 'number' ? opts.expectIncreaseFrom : null;
    syncInFlight = Promise.all([refreshCartCount(), refreshCartDrawer()])
      .then(function (results) {
        var cart = results[0];
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : lastKnownCount;
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'inline-sync' } }));
        } catch (e) {}
        var grew = before != null && typeof count === 'number' && count > before;
        if (opts.openDrawer) openFineriCartDrawer();
        return cart;
      })
      .finally(function () {
        syncInFlight = null;
      });
    return syncInFlight;
  }

  function scheduleSync(options) {
    var opts = options || {};
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncCartUi(opts);
    }, typeof opts.delay === 'number' ? opts.delay : 80);
  }

  function pollAfterAdd(beforeCount) {
    window.setTimeout(function () {
      if (readBadgeCount() > beforeCount) return;
      if (window.__fineriCartUiStamp && Date.now() - window.__fineriCartUiStamp < 1600) return;
      syncCartUi({ openDrawer: false, expectIncreaseFrom: beforeCount });
    }, 800);
  }

  function pathFromUrl(url) {
    if (!url) return '';
    try {
      var u = String(url);
      if (u.indexOf('http') === 0 || u.indexOf('//') === 0) {
        return new URL(u, window.location.origin).pathname;
      }
      return u.split('?')[0];
    } catch (e) {
      return String(url);
    }
  }

  function isCartAddUrl(url) {
    var path = pathFromUrl(url);
    return /\/cart\/add(\.js)?\/?$/.test(path) || path.indexOf('/cart/add') !== -1;
  }

  function isCartMutateUrl(url) {
    var path = pathFromUrl(url);
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(path);
  }

  function patchFetch() {
    if (typeof window.fetch !== 'function' || window.fetch.__fineriInlinePatched) return;
    var nativeFetch = window.fetch.bind(window);
    function patched(input, init) {
      var url = '';
      if (typeof input === 'string') url = input;
      else if (input && typeof input.url === 'string') url = input.url;
      var req = nativeFetch(input, init);
      if (!isCartMutateUrl(url)) return req;
      return req.then(function (res) {
        if (res && res.ok) {
          scheduleSync({ openDrawer: false, delay: 60 });
        }
        return res;
      });
    }
    patched.__fineriInlinePatched = true;
    window.fetch = patched;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__fineriInlinePatched) return;
    var XHR = window.XMLHttpRequest;
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__fineriUrl = url;
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function () {
      var xhr = this;
      var url = xhr.__fineriUrl || '';
      if (isCartMutateUrl(url)) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            scheduleSync({ openDrawer: false, delay: 60 });
          }
        });
      }
      return send.apply(this, arguments);
    };
    XHR.__fineriInlinePatched = true;
  }

  patchFetch();
  patchXhr();
  // Re-assert patch if another script wraps fetch later.
  window.setTimeout(patchFetch, 1000);
  window.setTimeout(patchFetch, 3000);

  document.addEventListener(
    'click',
    function (ev) {
      var btn =
        ev.target && ev.target.closest
          ? ev.target.closest(
              '[data-add-to-bag], [data-fineri-sticky-atc-submit], .fineri-plp-card__atc-btn, .fineri-quick-view__submit[data-qv-submit-mode="cart"]'
            )
          : null;
      if (!btn || btn.disabled) return;
      var before = readBadgeCount();
      pollAfterAdd(before);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (
        !(
          form.classList.contains('fineri-pdp__form') ||
          form.classList.contains('fineri-plp-card__atc-form') ||
          form.classList.contains('fineri-quick-view__form')
        )
      ) {
        return;
      }
      var before = readBadgeCount();
      pollAfterAdd(before);
    },
    true
  );

  document.addEventListener('cart:added', function () {
    scheduleSync({ openDrawer: false, delay: 40 });
  });

  window.fineriRefreshCartCount = function () {
    return refreshCartCount();
  };
  window.fineriSyncCartUi = function (openDrawer) {
    return syncCartUi({ openDrawer: !!openDrawer });
  };
})();
